// extracted by mini-css-extract-plugin
export default {"verification-container":"Verification_verification-container_GKm9QDf100QgNktXz6lM","verification-form":"Verification_verification-form_Ai7N8zffTcK9siAPkmZ7"};